
// export enum TaskStatus {
//   DESIGNATE = 10, // 待指派
//   PROCESSING = 20, // 进行中
//   CHANGED = 30, // 已变更
//   COMPLETED = 40, // 已完成
//   CLOSE = 50, // 已关闭
// }

/**
 * @description 标签类型
 */
// export enum LabelType {
//   System = 1, // 系统标签
//   NetPlan = 2, // 网规标签
//   Custom = 3 // 自定义标签
// }

// A、B、C、D标签（网规标签）
// export const labelType = [
//   'https://staticres.linhuiba.com/project-custom/locationpc/label/label_A@2x.png',
//   'https://staticres.linhuiba.com/project-custom/locationpc/label/label_B@2x.png',
//   'https://staticres.linhuiba.com/project-custom/locationpc/label/label_C@2x.png',
//   'https://staticres.linhuiba.com/project-custom/locationpc/label/label_D@2x.png',
// ];
/*
  网规标签名称与图片对应map

  使用方法：
  拿到标签名称label后，
  const imgUrl = typeLabelImgMap.get(label) || ''
*/
// export const typeLabelImgMap = new Map([
//   ['A类', labelType[0]],
//   ['B类', labelType[1]],
//   ['C类', labelType[2]],
//   ['D类', labelType[3]],
// ]);

// 非商场类型机会点
// export const targetChancepoint: string[] = [
//   'CHANCE_POINT'
// ];

// 非商场类型经营门店
export const targetShops: string[] = [
  'FAMOUS_BRAND', // 知名品牌
  'COMPETITORS', // 竞品门店
  'RESTAURANT', // 餐饮
  'SHOPPING', // 购物
  'LIFE_SERVICE', // 生活服务
  'EDUCATION', // 教育培训
  'RECREATION', // 休闲娱乐
  'FITNESS', // 运动健身
  'HOTEL', // 酒店住宿
  'VEHICLE_SERVICE', // 汽车服务
];

// 商场类型机会点
// export const targetMallChancepoint: string[] = [
//   'MALL_CHANCE_POINT'
// ];

// 商场类型经营门店
export const targetMallShops: string[] = [
  'MALL_FAMOUS_BRAND',
  'MALL_COMPETITORS',
  'MALL_RESTAURANT',
  'MALL_SHOPPING',
  'MALL_LIFE_SERVICE',
  'MALL_EDUCATION',
  'MALL_RECREATION',
  'MALL_FITNESS',
  'MALL_HOTEL',
  'MALL_VEHICLE_SERVICE',
];

// 周边配套
export const targetSurrounding: string[] = [
  'ZHU_ZHAI',
  'GOU_WU',
  'BAN_GONG',
  'XUE_XIAO',
  'YI_LIAO',
  'JIAO_TONG',
  'JING_QU',
];

export const targetLegendIcon = {
  // 机会点
  'CHANCE_POINT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_chancepoint.png',
  'MALL_CHANCE_POINT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_chancepoint.png',
  // 非商场经营门店：
  'FAMOUS_BRAND': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_famous_brand.png',
  'COMPETITORS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_competitor.png',
  'RESTAURANT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_catering.png',
  'SHOPPING': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_shopping.png',
  'LIFE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_service_life.png',
  'EDUCATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_education.png',
  'RECREATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_recreation.png',
  'FITNESS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_exercise.png',
  'HOTEL': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_hotel.png',
  'VEHICLE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_car.png',
  // 商场经营门店：
  'MALL_FAMOUS_BRAND': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_famous_brand.png',
  'MALL_COMPETITORS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_competitor.png',
  'MALL_RESTAURANT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_catering.png',
  'MALL_SHOPPING': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_shopping.png',
  'MALL_LIFE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_service_life.png',
  'MALL_EDUCATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_education.png',
  'MALL_RECREATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_recreation.png',
  'MALL_FITNESS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_exercise.png',
  'MALL_HOTEL': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_hotel.png',
  'MALL_VEHICLE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_car.png',
  // 周边配套
  'ZHU_ZHAI': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_housing.png',
  'GOU_WU': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_business.png',
  'BAN_GONG': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_work.png',
  'XUE_XIAO': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_school.png',
  'YI_LIAO': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_hospital.png',
  'JIAO_TONG': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_traffic.png',
  'JING_QU': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_scenic.png',
};

// 选址地图详情中新的经营门店图例
export const detailTargetLegendIcon = {
  // 非商场型
  'FAMOUS_BRAND': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_famous_brand@3x.png',
  'COMPETITORS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_competitor@3x.png',
  'RESTAURANT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_catering@3x.png',
  'SHOPPING': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_shopping@3x.png',
  'LIFE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_service_life@3x.png',
  'EDUCATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_education@3x.png',
  'RECREATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_recreation@3x.png',
  'FITNESS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_exercise@3x.png',
  'HOTEL': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_hotel@3x.png',
  'VEHICLE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_car@3x.png',
  // 商场型
  'MALL_FAMOUS_BRAND': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_famous_brand@3x.png',
  'MALL_COMPETITORS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_competitor@3x.png',
  'MALL_RESTAURANT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_catering@3x.png',
  'MALL_SHOPPING': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_shopping@3x.png',
  'MALL_LIFE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_service_life@3x.png',
  'MALL_EDUCATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_education@3x.png',
  'MALL_RECREATION': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_recreation@3x.png',
  'MALL_FITNESS': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_exercise@3x.png',
  'MALL_HOTEL': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_hotel@3x.png',
  'MALL_VEHICLE_SERVICE': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_car@3x.png',
};

// 选址地图首页中显示的图例
// export const homeTargetLegendIcon = {
//   'BRAND': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_brand.png',
//   'COLLECT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_collect.png',
//   'OPEN_AREA': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_open_area.png',
//   'OPENED': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_opened.png',
//   'POINT': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_point.png',
//   'SUBWAY': 'https://staticres.linhuiba.com/project-custom/location2.0/map-legend/icon_legend_subway.png',
//   'PROTECT': 'https://staticres.linhuiba.com/project-custom/locationpc/selectionmap/icon_site_areaProtect.png',
// };
